module.exports = __webpack_public_path__ + "media/images/defaults/featured_content_image/slider-49e1739f16f03217eb4d4ffd4d3cc168.png";